<template>
  <div class="item" :class="{hasIcon: hasIcon, disabledMobile: item.data.disabledMobile, disabledTablet: item.data.disabledTablet}">
    <div class="inner">
      <img v-if="typeof (item.data.icon) !== 'undefined' && item.data.icon !== ''" :src="item.data.icon" class="icon" alt="" />
      <img v-if="typeof (item.data.icon2) !== 'undefined' && item.data.icon2 !== ''" :src="item.data.icon2" class="icon icon2" alt="" />
      <SetLink
      :linkTarget="item.data"
      :linkText="item.data.label"
      :lang="lang" />
      <button v-if="item.children && item.children.length" type="button" :class="{openChildren: true, open: state.open}" @click="openChildren">
        <span class="left" :style="barColor"></span>
        <span class="right" :style="barColor"></span>
        <span class="blind">open</span>
      </button>
    </div>
    <div v-if="item.children && item.children.length && state.open" class="list">
      <MenuItem
        v-for="item in item.children"
        :key="item.id"
        :lang="lang"
        :item="item" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'MenuItem',
  props: [
    'lang',
    'item',
    'responsive'
  ],
  components: {
    SetLink
  },
  computed: {
    ...mapGetters({
      link: 'util/setLink'
    }),
    barColor () {
      const color = this.$store.getters['common/getSetting'].colors.menuText
      return {
        backgroundColor: color
      }
    },
    hasIcon () {
      const onMobile = this.responsive === 'mobile' && this.item.data.icon && this.item.data.icon !== ''
      const onTablet = this.responsive === 'tablet' && this.item.data.icon2 && this.item.data.icon2 !== ''
      return onMobile || onTablet
    }
  },
  data () {
    return {
      state: {
        open: false
      }
    }
  },
  methods: {
    setLink (target) {
      return this.link(target)
    },
    openChildren () {
      this.state.open = !this.state.open
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .disabledTablet {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .disabledMobile {
    display: none;
  }
}
</style>
